// Auto-generated SEO mappings
export interface SeoConfig {
  title: string;
  description: string;
  path: string; // e.g. '/tech-blogs/ai-coding-tools-for-developers'
  ogImage?: string; // absolute URL; default = company OG image
  ogType?: 'website' | 'article';
  publishedDate?: string; // ISO date for articles
}

export const ROUTE_SEO_DATA: Record<string, SeoConfig> = {
  "/": {
    "title": "Kalpita Technologies | AI-First Software & Data Engineering",
    "description": "AI-first digital transformation partner. 130+ specialists deliver Data & AI, software engineering, and digital products for insurtech, fintech & healthcare.",
    "path": "/"
  },
  "/aboutcompany/about-kalpita-technologies": {
    "title": "About Kalpita Technologies | Kalpita Technologies",
    "description": "Explore our About Kalpita Technologies page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/aboutcompany/about-kalpita-technologies"
  },
  "/aboutcompany/kalpita-csr": {
    "title": "Kalpita Csr | Kalpita Technologies",
    "description": "Explore our Kalpita Csr page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/aboutcompany/kalpita-csr"
  },
  "/aboutcompany/kalpita-annual-reports": {
    "title": "Kalpita Annual Reports | Kalpita Technologies",
    "description": "Explore our Kalpita Annual Reports page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/aboutcompany/kalpita-annual-reports"
  },
  "/careers/career-at-kalpita": {
    "title": "Career At Kalpita | Kalpita Technologies",
    "description": "Explore our Career At Kalpita page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/careers/career-at-kalpita"
  },
  "/gallery/life-at-kalpita": {
    "title": "Life At Kalpita | Kalpita Technologies",
    "description": "Explore our Life At Kalpita page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/gallery/life-at-kalpita"
  },
  "/gallery/learn-with-kalpita": {
    "title": "Learn With Kalpita | Kalpita Technologies",
    "description": "Explore our Learn With Kalpita page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/gallery/learn-with-kalpita"
  },
  "/company-services/custom-software-development": {
    "title": "Custom Software Development | Kalpita Technologies",
    "description": "Explore our Custom Software Development page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/company-services/custom-software-development"
  },
  "/company-services/web-development": {
    "title": "Web Development | Kalpita Technologies",
    "description": "Explore our Web Development page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/company-services/web-development"
  },
  "/company-services/mobile-app-development": {
    "title": "Mobile App Development | Kalpita Technologies",
    "description": "Explore our Mobile App Development page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/company-services/mobile-app-development"
  },
  "/company-services/ui-ux-design": {
    "title": "Ui Ux Design | Kalpita Technologies",
    "description": "Explore our Ui Ux Design page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/company-services/ui-ux-design"
  },
  "/company-services/testing-qa": {
    "title": "Testing Qa | Kalpita Technologies",
    "description": "Explore our Testing Qa page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/company-services/testing-qa"
  },
  "/company-services/it-consulting": {
    "title": "It Consulting | Kalpita Technologies",
    "description": "Explore our It Consulting page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/company-services/it-consulting"
  },
  "/company-services/digital-marketing": {
    "title": "Digital Marketing | Kalpita Technologies",
    "description": "Explore our Digital Marketing page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/company-services/digital-marketing"
  },
  "/company-services/data-engineering": {
    "title": "Data Engineering | Kalpita Technologies",
    "description": "Explore our Data Engineering page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/company-services/data-engineering"
  },
  "/company-services/ai-as-a-service": {
    "title": "Ai As A Service | Kalpita Technologies",
    "description": "Explore our Ai As A Service page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/company-services/ai-as-a-service"
  },
  "/industries/insurtech": {
    "title": "Insurtech | Kalpita Technologies",
    "description": "Explore our Insurtech page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/industries/insurtech"
  },
  "/industries/fintech": {
    "title": "Fintech | Kalpita Technologies",
    "description": "Explore our Fintech page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/industries/fintech"
  },
  "/industries/healthtech": {
    "title": "Healthtech | Kalpita Technologies",
    "description": "Explore our Healthtech page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/industries/healthtech"
  },
  "/industries/ecommerce": {
    "title": "Ecommerce | Kalpita Technologies",
    "description": "Explore our Ecommerce page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/industries/ecommerce"
  },
  "/industries/media-entertainment": {
    "title": "Media Entertainment | Kalpita Technologies",
    "description": "Explore our Media Entertainment page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/industries/media-entertainment"
  },
  "/industries/hitech": {
    "title": "Hitech | Kalpita Technologies",
    "description": "Explore our Hitech page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/industries/hitech"
  },
  "/industries/edtech": {
    "title": "Edtech | Kalpita Technologies",
    "description": "Explore our Edtech page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/industries/edtech"
  },
  "/kalpita-case-studies/saas-launch": {
    "title": "Saas Launch - Case Study | Kalpita Technologies",
    "description": "Explore our Saas Launch page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/saas-launch"
  },
  "/kalpita-case-studies/smart-integration": {
    "title": "Smart Integration - Case Study | Kalpita Technologies",
    "description": "Explore our Smart Integration page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/smart-integration"
  },
  "/kalpita-case-studies/unified-portal": {
    "title": "Unified Portal - Case Study | Kalpita Technologies",
    "description": "Explore our Unified Portal page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/unified-portal"
  },
  "/kalpita-case-studies/organized-portal": {
    "title": "Organized Portal - Case Study | Kalpita Technologies",
    "description": "Explore our Organized Portal page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/organized-portal"
  },
  "/kalpita-case-studies/implemented-datamigration": {
    "title": "Implemented Datamigration - Case Study | Kalpita Technologies",
    "description": "Explore our Implemented Datamigration page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/implemented-datamigration"
  },
  "/kalpita-case-studies/custom-sharepoint": {
    "title": "Custom Sharepoint - Case Study | Kalpita Technologies",
    "description": "Explore our Custom Sharepoint page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/custom-sharepoint"
  },
  "/kalpita-case-studies/guard-dog-page": {
    "title": "Guard Dog Page - Case Study | Kalpita Technologies",
    "description": "Explore our Guard Dog Page page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/guard-dog-page"
  },
  "/kalpita-case-studies/meet-business": {
    "title": "Meet Business - Case Study | Kalpita Technologies",
    "description": "Explore our Meet Business page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/meet-business"
  },
  "/kalpita-case-studies/data-obfuscation": {
    "title": "Data Obfuscation - Case Study | Kalpita Technologies",
    "description": "Explore our Data Obfuscation page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/data-obfuscation"
  },
  "/kalpita-case-studies/custom-web-development": {
    "title": "Custom Web Development - Case Study | Kalpita Technologies",
    "description": "Explore our Custom Web Development page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/custom-web-development"
  },
  "/kalpita-case-studies/us-retirement-plan": {
    "title": "Us Retirement Plan - Case Study | Kalpita Technologies",
    "description": "Explore our Us Retirement Plan page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/us-retirement-plan"
  },
  "/kalpita-case-studies/aidriven-insurance-application": {
    "title": "Aidriven Insurance Application - Case Study | Kalpita Technologies",
    "description": "Explore our Aidriven Insurance Application page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/aidriven-insurance-application"
  },
  "/kalpita-case-studies/unified-system-insurance": {
    "title": "Unified System Insurance - Case Study | Kalpita Technologies",
    "description": "Explore our Unified System Insurance page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/unified-system-insurance"
  },
  "/kalpita-case-studies/ai-powered-recruitment-tool": {
    "title": "Ai Powered Recruitment Tool - Case Study | Kalpita Technologies",
    "description": "Explore our Ai Powered Recruitment Tool page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-case-studies/ai-powered-recruitment-tool"
  },
  "/kalpita-white-papers/onlinemovie-ticket-booking": {
    "title": "Onlinemovie Ticket Booking - White Paper | Kalpita Technologies",
    "description": "Explore our Onlinemovie Ticket Booking page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-white-papers/onlinemovie-ticket-booking"
  },
  "/kalpita-white-papers/seatlayout-workflow": {
    "title": "Seatlayout Workflow - White Paper | Kalpita Technologies",
    "description": "Explore our Seatlayout Workflow page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-white-papers/seatlayout-workflow"
  },
  "/kalpita-white-papers/intro-design-patterns": {
    "title": "Intro Design Patterns - White Paper | Kalpita Technologies",
    "description": "Explore our Intro Design Patterns page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-white-papers/intro-design-patterns"
  },
  "/kalpita-white-papers/creational-design-patterns": {
    "title": "Creational Design Patterns - White Paper | Kalpita Technologies",
    "description": "Explore our Creational Design Patterns page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-white-papers/creational-design-patterns"
  },
  "/kalpita-white-papers/structural-design-patterns": {
    "title": "Structural Design Patterns - White Paper | Kalpita Technologies",
    "description": "Explore our Structural Design Patterns page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-white-papers/structural-design-patterns"
  },
  "/kalpita-white-papers/behavioural-design-patterns": {
    "title": "Behavioural Design Patterns - White Paper | Kalpita Technologies",
    "description": "Explore our Behavioural Design Patterns page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-white-papers/behavioural-design-patterns"
  },
  "/kalpita-white-papers/it-trends": {
    "title": "It Trends - White Paper | Kalpita Technologies",
    "description": "Explore our It Trends page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-white-papers/it-trends"
  },
  "/kalpita-white-papers/agentic-ai-in-sdlc": {
    "title": "Agentic Ai In Sdlc - White Paper | Kalpita Technologies",
    "description": "Explore our Agentic Ai In Sdlc page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-white-papers/agentic-ai-in-sdlc"
  },
  "/kalpita-white-papers/rise-of-ai-agent": {
    "title": "Rise Of Ai Agent - White Paper | Kalpita Technologies",
    "description": "Explore our Rise Of Ai Agent page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-white-papers/rise-of-ai-agent"
  },
  "/kalpita-white-papers/autonomous-machine-revolution": {
    "title": "Autonomous Machine Revolution - White Paper | Kalpita Technologies",
    "description": "Explore our Autonomous Machine Revolution page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-white-papers/autonomous-machine-revolution"
  },
  "/kalpita-tech-geek/techgeek-6": {
    "title": "Techgeek 6 | Kalpita Technologies",
    "description": "Explore our Techgeek 6 page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-tech-geek/techgeek-6"
  },
  "/kalpita-tech-geek/techgeek-5": {
    "title": "Techgeek 5 | Kalpita Technologies",
    "description": "Explore our Techgeek 5 page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-tech-geek/techgeek-5"
  },
  "/kalpita-tech-geek/techgeek-4": {
    "title": "Techgeek 4 | Kalpita Technologies",
    "description": "Explore our Techgeek 4 page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-tech-geek/techgeek-4"
  },
  "/kalpita-tech-geek/techgeek-3": {
    "title": "Techgeek 3 | Kalpita Technologies",
    "description": "Explore our Techgeek 3 page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-tech-geek/techgeek-3"
  },
  "/kalpita-tech-geek/techgeek-2": {
    "title": "Techgeek 2 | Kalpita Technologies",
    "description": "Explore our Techgeek 2 page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-tech-geek/techgeek-2"
  },
  "/kalpita-tech-geek/techgeek-1": {
    "title": "Techgeek 1 | Kalpita Technologies",
    "description": "Explore our Techgeek 1 page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-tech-geek/techgeek-1"
  },
  "/kalpita-press-release/kalpita-technologies-great-place-to-work-certified": {
    "title": "Kalpita Technologies Great Place To Work Certified | Kalpita Technologies",
    "description": "Explore our Kalpita Technologies Great Place To Work Certified page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-press-release/kalpita-technologies-great-place-to-work-certified"
  },
  "/kalpita-press-release/goodfirms": {
    "title": "Goodfirms | Kalpita Technologies",
    "description": "Explore our Goodfirms page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-press-release/goodfirms"
  },
  "/kalpita-press-release/pioneering-ai": {
    "title": "Pioneering Ai | Kalpita Technologies",
    "description": "Explore our Pioneering Ai page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-press-release/pioneering-ai"
  },
  "/kalpita-press-release/about-kalpita": {
    "title": "About Kalpita | Kalpita Technologies",
    "description": "Explore our About Kalpita page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-press-release/about-kalpita"
  },
  "/kalpita-press-release/about-ceo": {
    "title": "About Ceo | Kalpita Technologies",
    "description": "Explore our About Ceo page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-press-release/about-ceo"
  },
  "/kalpita-press-release/influential-business": {
    "title": "Influential Business | Kalpita Technologies",
    "description": "Explore our Influential Business page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-press-release/influential-business"
  },
  "/kalpita-press-release/kalpita-sixth-anniversary": {
    "title": "Kalpita Sixth Anniversary | Kalpita Technologies",
    "description": "Explore our Kalpita Sixth Anniversary page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/kalpita-press-release/kalpita-sixth-anniversary"
  },
  "/tech-blogs/data-visualization-skills-2026": {
    "title": "Data Visualization Skills 2026 - Tech Blog | Kalpita Technologies",
    "description": "Explore our Data Visualization Skills 2026 page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/data-visualization-skills-2026"
  },
  "/tech-blogs/ai-coding-tools-for-developers": {
    "title": "10 Best AI Coding Tools for Developers in 2026",
    "description": "GitHub Copilot, Cursor, Claude Code, Google Antigravity & more. Compare the 10 best AI coding tools for developers in 2026 and pick the right one for your team.",
    "path": "/tech-blogs/ai-coding-tools-for-developers"
  },
  "/tech-blogs/autonomous-machine-revolution": {
    "title": "Autonomous Machine Revolution - Tech Blog | Kalpita Technologies",
    "description": "Explore our Autonomous Machine Revolution page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/autonomous-machine-revolution"
  },
  "/tech-blogs/ai-agents-in-enterprises": {
    "title": "Ai Agents In Enterprises - Tech Blog | Kalpita Technologies",
    "description": "Explore our Ai Agents In Enterprises page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/ai-agents-in-enterprises"
  },
  "/tech-blogs/agentic-ai-in-sdlc": {
    "title": "Agentic Ai In Sdlc - Tech Blog | Kalpita Technologies",
    "description": "Explore our Agentic Ai In Sdlc page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/agentic-ai-in-sdlc"
  },
  "/tech-blogs/agi-implementation-guide": {
    "title": "Agi Implementation Guide - Tech Blog | Kalpita Technologies",
    "description": "Explore our Agi Implementation Guide page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/agi-implementation-guide"
  },
  "/tech-blogs/rag-chatbot": {
    "title": "Rag Chatbot - Tech Blog | Kalpita Technologies",
    "description": "Explore our Rag Chatbot page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/rag-chatbot"
  },
  "/tech-blogs/artificial-general-intelligence-agi": {
    "title": "Artificial General Intelligence Agi - Tech Blog | Kalpita Technologies",
    "description": "Explore our Artificial General Intelligence Agi page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/artificial-general-intelligence-agi"
  },
  "/tech-blogs/aitools-project-management": {
    "title": "Aitools Project Management - Tech Blog | Kalpita Technologies",
    "description": "Explore our Aitools Project Management page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/aitools-project-management"
  },
  "/tech-blogs/build-website-ai-tools": {
    "title": "Build Website Ai Tools - Tech Blog | Kalpita Technologies",
    "description": "Explore our Build Website Ai Tools page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/build-website-ai-tools"
  },
  "/tech-blogs/agentic-ai": {
    "title": "Agentic Ai - Tech Blog | Kalpita Technologies",
    "description": "Explore our Agentic Ai page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/agentic-ai"
  },
  "/tech-blogs/ios-updates": {
    "title": "Ios Updates - Tech Blog | Kalpita Technologies",
    "description": "Explore our Ios Updates page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/ios-updates"
  },
  "/tech-blogs/devops-guide": {
    "title": "Devops Guide - Tech Blog | Kalpita Technologies",
    "description": "Explore our Devops Guide page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/devops-guide"
  },
  "/tech-blogs/custom-web-development": {
    "title": "Custom Web Development - Tech Blog | Kalpita Technologies",
    "description": "Explore our Custom Web Development page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/custom-web-development"
  },
  "/tech-blogs/data-obfuscation": {
    "title": "Data Obfuscation - Tech Blog | Kalpita Technologies",
    "description": "Explore our Data Obfuscation page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/data-obfuscation"
  },
  "/tech-blogs/digital-challenges": {
    "title": "Digital Challenges - Tech Blog | Kalpita Technologies",
    "description": "Explore our Digital Challenges page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/digital-challenges"
  },
  "/tech-blogs/digital-transformation": {
    "title": "Digital Transformation - Tech Blog | Kalpita Technologies",
    "description": "Explore our Digital Transformation page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/digital-transformation"
  },
  "/tech-blogs/business-process-automation": {
    "title": "Business Process Automation - Tech Blog | Kalpita Technologies",
    "description": "Explore our Business Process Automation page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/business-process-automation"
  },
  "/tech-blogs/software-requirement-analysis": {
    "title": "Software Requirement Analysis - Tech Blog | Kalpita Technologies",
    "description": "Explore our Software Requirement Analysis page to learn more about Kalpita Technologies' offerings and expertise.",
    "path": "/tech-blogs/software-requirement-analysis"
  }
};
